import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, X as CloseIcon, Globe } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-193">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-194">
        <div className="flex justify-between items-center h-20" data-id="element-195">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-196">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/vJ4LnEANA2qYvkkH1pNfQy/design-d5307099-5cbb-4264-b386-3c96f879a243.png" alt="Farasha Medical Aid Logo" className="h-12 w-auto" data-id="element-197" />
            <span className="ml-3 text-primary-deep-blue font-playfair font-semibold" data-id="element-198">
              Farasha Medical Aid
            </span>
          </Link>
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8" data-id="element-199">
            <Link to="/" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-200">
              Home
            </Link>
            <Link to="/how-it-works" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-201">
              How It Works
            </Link>
            <Link to="/impact" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-202">
              Impact
            </Link>
            <Link to="/get-involved" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-203">
              Get Involved
            </Link>
            <Link to="/about" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-204">
              About
            </Link>
            <Link to="/blog" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-205">
              Blog
            </Link>
            <Link to="/partners" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-206">
              Partners
            </Link>
            <Link to="/faq" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-207">
              FAQ
            </Link>
            <Link to="/contact" className="text-primary-deep-blue hover:text-primary-royal-blue font-inter" data-id="element-208">
              Contact
            </Link>
          </nav>
          {/* Action Buttons */}
          <div className="hidden md:flex items-center space-x-4" data-id="element-209">
            <button className="p-2 rounded-full text-primary-deep-blue hover:bg-neutral-offwhite" data-id="element-210">
              <Globe size={20} data-id="element-211" />
            </button>
            <Link to="/donate" className="bg-primary-royal-blue hover:bg-primary-deep-blue text-white px-4 py-2 rounded-md font-inter transition-colors" data-id="element-212">
              Donate
            </Link>
          </div>
          {/* Mobile menu button */}
          <div className="md:hidden flex items-center" data-id="element-213">
            <button onClick={toggleMenu} className="inline-flex items-center justify-center p-2 rounded-md text-primary-deep-blue hover:bg-neutral-offwhite focus:outline-none" data-id="element-214">
              {isMenuOpen ? <CloseIcon size={24} data-id="element-215" /> : <MenuIcon size={24} data-id="element-216" />}
            </button>
          </div>
        </div>
      </div>
      {/* Mobile menu */}
      {isMenuOpen && <div className="md:hidden" data-id="element-217">
          <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white" data-id="element-218">
            <Link to="/" className="block px-3 py-2 text-primary-deep-blue font-inter" data-id="element-219">
              Home
            </Link>
            <Link to="/how-it-works" className="block px-3 py-2 text-primary-deep-blue font-inter" data-id="element-220">
              How It Works
            </Link>
            <Link to="/impact" className="block px-3 py-2 text-primary-deep-blue font-inter" data-id="element-221">
              Impact
            </Link>
            <Link to="/get-involved" className="block px-3 py-2 text-primary-deep-blue font-inter" data-id="element-222">
              Get Involved
            </Link>
            <Link to="/about" className="block px-3 py-2 text-primary-deep-blue font-inter" data-id="element-223">
              About
            </Link>
            <Link to="/blog" className="block px-3 py-2 text-primary-deep-blue font-inter" data-id="element-224">
              Blog
            </Link>
            <Link to="/partners" className="block px-3 py-2 text-primary-deep-blue font-inter" data-id="element-225">
              Partners
            </Link>
            <Link to="/faq" className="block px-3 py-2 text-primary-deep-blue font-inter" data-id="element-226">
              FAQ
            </Link>
            <Link to="/contact" className="block px-3 py-2 text-primary-deep-blue font-inter" data-id="element-227">
              Contact
            </Link>
            <Link to="/donate" className="block px-3 py-2 bg-primary-royal-blue text-white rounded-md font-inter" data-id="element-228">
              Donate
            </Link>
            <button className="flex items-center px-3 py-2 text-primary-deep-blue font-inter" data-id="element-229">
              <Globe size={18} className="mr-2" data-id="element-230" /> Language
            </button>
          </div>
        </div>}
    </header>;
}